import { Link } from 'react-router';

import logo from '/img/imagotipo.svg'

const Logo = () => {

    return (
        <div className="logo _l">
            <Link to="/" className="no-txt"> <span>Ir a Home</span> <img src={logo} alt="Logo"/> </Link>
            <div className="title">
                <div>Imágenes de</div>
                <div>histopatología veterinaria</div>
            </div>
        </div>
    );
};

export default Logo;
